export const bannerType = [
  { label: 'Casino Banner', value: 'Casino Banner' },
]

export const AffiliateStatus = [
  { label: 'Approved', value: 'approved' },,
  { label: 'Rejected', value: 'rejected' },
]
